import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface ComplianceWithLawsAndRegulationsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function ComplianceWithLawsAndRegulationsInternalControls({ onBack, setActiveSection, controlsListSection }: ComplianceWithLawsAndRegulationsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Compliance with Laws and Regulations"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
